/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 11);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (str) {
	var ua = window.navigator.userAgent.toLowerCase();
	return ua.indexOf(str) !== -1;
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ua = __webpack_require__(0);
var FnTop = __webpack_require__(6);
var topNews = __webpack_require__(9);
var topNewsSlider = __webpack_require__(10);
var TopMainvisual = __webpack_require__(7);
var topMainvisualEffect = __webpack_require__(8);
var serviceIndex = __webpack_require__(5);
var fnNews = __webpack_require__(4);
var runInview = __webpack_require__(16);
var headerScroll = __webpack_require__(14);
var formCtr = __webpack_require__(3);
var setWrapMargin = __webpack_require__(19);
var runWoookmark = __webpack_require__(17);
var setBtnPageTop = __webpack_require__(13);
var initMap = __webpack_require__(2);

var Pjax = {

	init: function init() {
		var that = this;
		if ((ua('iphone') || ua('android')) && ($('body')[0].getAttribute('data-category') == 'top' || $('body')[0].getAttribute('data-category') == 'access')) {
			$('meta[name="viewport"]')[0].setAttribute('content', 'width=device-width, initial-scale=1.0');
		}

		that.setObj();
		that.$window.on('load', function (e) {
			that.onLoad();
			setTimeout(function () {
				$('.loading').addClass('is--hide');
			}, 500);
			setTimeout(function () {
				runInview();
			}, 500);
		});
		that.$window.on('load resize', function (e) {
			new TopMainvisual();
		});
		that.$document.on('click', '.link--scroll', function (e) {
			e.preventDefault();
			$('html,body').animate({ scrollTop: $($(this).attr('href')).offset().top - 102 }, 'swing');
		});
		that.$document.on('click', '.link--pjax', function (e) {
			sessionStorage.entrance = 'is--hide';
			$('.entrance').addClass('is--hide--r');
			$('.menu-trigger').removeClass('is--active');
			$('.gnav').removeClass('is--active');
			$('.header .title').removeClass('is--active');
			that.onClick(e, this, 0);
		});
		that.$document.on('click', '.link--pjax--snav', function (e) {
			that.onClick(e, this, 374);
			$('.header').addClass('is--scroll');
		});
		that.$document.on('click', '.link--pjax--pagenav', function (e) {
			that.onClick(e, this, 374);
			$('.header').addClass('is--scroll');
		});
		that.$document.on('click', '.link--pjax--work--localize', function (e) {
			that.onClick(e, this, 1230);
		});
		that.$document.on('click', '.link--pjax--work--illust', function (e) {
			that.onClick(e, this, 1510);
		});
		that.$document.on('click', '.link--pjax--work--promo', function (e) {
			that.onClick(e, this, 1240);
		});
		that.$window.on('popstate', function (e) {
			that.onPopState(e);
		});
	},
	setObj: function setObj() {
		this.$window = $(window);
		this.$document = $(document);
		this.$link_pjax = $('.link--pjax');
		this.$wrap = $('.wrap');
		this.$container = $('.container');
	},
	onLoad: function onLoad() {
		var current = this.getCurrentPath().split('/');
		current = current[current.length - 1];

		history.replaceState(this.pushStateObj(current), current.split('.')[0], null);

		if (ua('iphone')) {
			$(document).on('click', '.menu-trigger', function (e) {
				e.preventDefault();
				$(this).toggleClass('is--active');
				$('.gnav').toggleClass('is--active');
				$('.header .title').toggleClass('is--active');
			});
		} else if (ua('android')) {
			$(document).on('click', '.menu-trigger', function (e) {
				e.preventDefault();
				$(this).toggleClass('is--active');
				$('.gnav').toggleClass('is--active');
				$('.header .title').toggleClass('is--active');
			});
		} else {
			new FnTop();
			topNews();
			topNewsSlider();
			fnNews();
			topMainvisualEffect();
			serviceIndex();
			setWrapMargin();
		}
		if ($('body')[0].getAttribute('data-category') == 'access') {
			initMap.muromachi();
			initMap.tokyo();
			initMap.jujo();
			initMap.akezu();
		}
		$('.entrance ul li:nth-of-type(2) a').on('click', function (e) {
			e.preventDefault();
			$('.entrance').addClass('is--hide');
			sessionStorage.entrance = 'is--hide';
		});
		headerScroll();
		setBtnPageTop();
		formCtr();
		runWoookmark();
		$('.header').removeClass('is--scrolls');
		this.$window.scrollTop(0);
	},
	onClick: function onClick(e, self, n) {
		e.preventDefault();

		var that = this;
		var target = $(self).attr('href');
		var page = target.split('.')[0];

		that.onFetch();
		history.pushState(this.pushStateObj(target), page, target);
		setTimeout(function () {
			that.changeCurrent(that.getCategory(), that.getPage());
			that.chageContents(target);
		}, 1000);
		setTimeout(function () {
			that.$window.scrollTop(n);
			new TopMainvisual();
		}, 1100);
	},
	onPopState: function onPopState(e) {
		var that = this;
		that.onFetch();
		setTimeout(function () {
			that.changeCurrent(that.getCategory(), that.getPage());
			that.$window.scrollTop(0);
			that.chageContents(that.getTarget(e));
		}, 1000);
		setTimeout(function () {
			new TopMainvisual();
		}, 1100);
	},
	onFetch: function onFetch() {
		//ページ遷移前の処理
		$('.loading').removeClass('is--hide');
		//$('.wrap').addClass('is--hide');
	},
	changeCurrent: function changeCurrent(category, page) {
		$('body')[0].setAttribute('data-category', category);
		if ((ua('iphone') || ua('android')) && ($('body')[0].getAttribute('data-category') == 'top' || $('body')[0].getAttribute('data-category') == 'access')) {
			$('meta[name="viewport"]')[0].setAttribute('content', 'width=device-width, initial-scale=1.0');
		} else if ((ua('iphone') || ua('android')) && ($('body')[0].getAttribute('data-category') != 'top' || $('body')[0].getAttribute('data-category') != 'access')) {
			$('meta[name="viewport"]')[0].setAttribute('content', 'width=1200, initial-scale=1.0');
		}
		$('body')[0].setAttribute('data-current', 'mainvisual');
		$('body')[0].setAttribute('data-page', category + '__' + page);
		$('.wrap')[0].setAttribute('data-category', category);
		$('.wrap')[0].setAttribute('data-page', category + '__' + page);
		$('.wrap')[0].setAttribute('data-current', 'mainvisual');
		$('.wrap').removeAttr('style');
		if ($('.container')[0]) {
			$('.container')[0].setAttribute('data-category', category);
			$('.container')[0].setAttribute('data-page', category + '__' + page);
		}
		if ($('.snav')[0]) {
			$('.snav')[0].setAttribute('data-page', category + '__' + page);
		}
		$('.header')[0].setAttribute('data-category', category);
	},
	chageContents: function chageContents(target) {
		this.$wrap.load(target + " " + '#wrap--inner', function (a, b, c) {
			//$('.wrap').removeClass('is--hide');
			var t = a.match(/<title>[\s\S]*?<\/title>/i)[0].replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '');
			document.title = t;

			if (!(ua('iphone') || ua('android'))) {
				fnNews();
				new TopMainvisual();
				topNews();
				serviceIndex();
				setWrapMargin();
			}

			if ($('.wrap')[0].getAttribute('data-page') != 'service__index') {
				$('body').removeAttr('style');
			}
			if ($(window).scrollTop() == 0) {
				$('.header').removeClass('is--scroll');
			}
			setTimeout(function () {
				$('.loading').addClass('is--hide');
			}, 500);
			setTimeout(function () {
				runInview();
			}, 500);
			if ($('body')[0].getAttribute('data-category') == 'access') {
				initMap.muromachi();
				initMap.tokyo();
				initMap.jujo();
				initMap.akezu();
			}
			headerScroll();
			setBtnPageTop();
			formCtr();
			runWoookmark();
			gtag('config', 'UA-118282026-1', { 'page_path': location.pathname.slice(1) });
		});
	},
	getCurrentPath: function getCurrentPath() {
		return location.pathname;
	},
	pushStateObj: function pushStateObj(target) {
		var state = { 'target': target };
		return state;
	},
	getTarget: function getTarget(e) {
		var state = e.originalEvent.state;
		return state.target;
	},
	getCategory: function getCategory() {
		var category = this.getCurrentPath().split('/')[1];
		if (category == '') {
			category = 'top';
		}
		return category;
	},
	getPage: function getPage() {
		var page = this.getCurrentPath().split('/')[2];
		if (page == undefined) {
			page = 'index';
		}
		return page;
	}
};

module.exports = Pjax;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var styleOptions = {};

var initMap = {
	muromachi: function muromachi() {
		var latlng = new google.maps.LatLng(34.997196, 135.757888);
		var opts = {
			zoom: 17,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			center: latlng
		};

		var map = new google.maps.Map(document.getElementById("mapHead"), opts);
		var markerOpts = {
			position: new google.maps.LatLng(34.997196, 135.757888),
			map: map,
			title: "marker"
		};
		var marker = new google.maps.Marker(markerOpts);

		var sampleType = new google.maps.StyledMapType(styleOptions);
		map.mapTypes.set('sample', sampleType);
		map.setMapTypeId('sample');

		google.maps.event.addListener(marker, 'click', function () {
			infowin.open(map, marker);
		});
	},
	tokyo: function tokyo() {
		var latlng = new google.maps.LatLng(35.694393, 139.693855);
		var opts = {
			zoom: 17,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			center: latlng
		};

		var map = new google.maps.Map(document.getElementById("mapTokyo"), opts);
		var markerOpts = {
			position: new google.maps.LatLng(35.694393, 139.693855),
			map: map,
			title: "marker"
		};
		var marker = new google.maps.Marker(markerOpts);

		var sampleType = new google.maps.StyledMapType(styleOptions);
		map.mapTypes.set('sample', sampleType);
		map.setMapTypeId('sample');

		google.maps.event.addListener(marker, 'click', function () {
			infowin.open(map, marker);
		});
	},
	jujo: function jujo() {
		var latlng = new google.maps.LatLng(34.97043908521924, 135.74948180099773);
		var opts = {
			zoom: 17,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			center: latlng
		};

		var map = new google.maps.Map(document.getElementById("mapJujo"), opts);
		var markerOpts = {
			position: new google.maps.LatLng(34.97043908521924, 135.74948180099773),
			map: map,
			title: "marker"
		};
		var marker = new google.maps.Marker(markerOpts);

		var sampleType = new google.maps.StyledMapType(styleOptions);
		map.mapTypes.set('sample', sampleType);
		map.setMapTypeId('sample');

		google.maps.event.addListener(marker, 'click', function () {
			infowin.open(map, marker);
		});
	},
	akezu: function akezu() {
		var latlng = new google.maps.LatLng(34.998161, 135.7599508);
		var opts = {
			zoom: 17,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			center: latlng
		};

		var map = new google.maps.Map(document.getElementById("mapAkezu"), opts);
		var markerOpts = {
			position: new google.maps.LatLng(34.998161, 135.76048),
			map: map,
			title: "marker"
		};
		var marker = new google.maps.Marker(markerOpts);

		var sampleType = new google.maps.StyledMapType(styleOptions);
		map.mapTypes.set('sample', sampleType);
		map.setMapTypeId('sample');

		google.maps.event.addListener(marker, 'click', function () {
			infowin.open(map, marker);
		});
	}
};

module.exports = initMap;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function formCtr() {
	var $textarea = $('textarea');
	$('form').on('submit', onSubmit);

	//onSubmit
	function onSubmit() {
		var text = $textarea.val();
		var isHTML = text.match(/<("[^"]*"|'[^']*'|[^'">])*>/i);
		var isEscape = text.match(/(\&lt;|\&gt;)/);
		var isURL = text.match(/(http:\/\/[\x21-\x7e]+)/i);

		if (isHTML || isEscape) {
			alert('お問い合わせ内容にHTMLタグは入力できません');
			return false;
		}
	}

	var $btnPrivacy = $('.btnPrivacy input');
	var $btnArea = $('.btnArea .form__submit');

	$btnPrivacy.prop("checked", false);
	$btnArea.attr("disabled", "disabled");
	$btnArea.addClass('is--lock');

	$btnPrivacy.click(function () {
		var btnType = $btnArea.attr('type');
		if (this.checked) {
			$btnArea.removeAttr("disabled");
			$btnArea.removeClass('is--lock');
		} else {
			$btnArea.attr("disabled", "disabled");
			$btnArea.addClass('is--lock');
		}
	});
}

module.exports = formCtr;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function fnNews() {
	$('.snav[data-page="news__index"] ul li a').on('click', function (e) {
		e.preventDefault();
		var select = $(this).parent()[0].getAttribute('data-select');
		$('.snav[data-page="news__index"] ul')[0].setAttribute('data-select', select);
		$('.container[data-page="news__index"] .pagenav ul')[0].setAttribute('data-select', select);
		$('.container[data-page="news__index"] .pagenav ul')[0].setAttribute('data-sort', "");
		$('.container[data-page="news__index"] .news--list')[0].setAttribute('data-sort', "ALL");
	});
	$('.container[data-page="news__index"] .pagenav li a').on('click', function (e) {
		e.preventDefault();
		var sort = $(this).parent()[0].getAttribute('data-sort');
		$('.container[data-page="news__index"] .pagenav ul')[0].setAttribute('data-sort', sort);
		$('.container[data-page="news__index"] .news--list')[0].setAttribute('data-sort', sort);
	});

	$('.accordion').on('click', function (e) {
		e.preventDefault();
		$(this).toggleClass('is--close');
		$(this).next('.accordion__ul').toggleClass('is--close');
	});
}
module.exports = fnNews;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//mousewheeleventのクロスブラウザ対策
if ('onwheel' in document) {
	var mousewheelevent = 'wheel';
} else if ('onmousewheel' in document) {
	var mousewheelevent = 'mousewheel';
} else {
	var mousewheelevent = 'DOMMouseScroll';
}

function serviceIndex() {
	if ($('.wrap')[0].getAttribute('data-page') == 'service__index') {
		var height = $(window).height();
		$(window).scrollTop(0);
		setTimeout(function () {
			$('body[data-page="service__index"]').css('overflow', 'hidden');
			$('.container[data-page="service__index"]').css('display', 'none');
			$('.wrap[data-page="service__index"] .mainvisual--title').css('height', height + 'px');
			$('.wrap[data-page="service__index"] .mainvisual--text').css('height', height + 'px');
		}, 100);
		$(window).on('scroll', function (e) {
			var top = $(window).scrollTop();
			if (top > height) {
				$('.wrap[data-page="service__index"] .mainvisual--text').hide();
			} else {
				$('.wrap[data-page="service__index"] .mainvisual--text').show();
			}
		});
	}
	$(window).on(mousewheelevent, function (e) {
		if ($('.wrap')[0].getAttribute('data-page') == 'service__index') {
			if (e.originalEvent.deltaY) {
				var delta = -e.originalEvent.deltaY;
			} else if (e.originalEvent.wheelDelta) {
				var delta = e.originalEvent.wheelDelta;
			} else {
				var delta = -e.origtruevent.detail;
			}
			console.log();
			if (delta < 0) {
				$('.wrap[data-page="service__index"] .mainvisual .message--service').addClass('is--scroll');
				$('.wrap[data-page="service__index"] .mainvisual h2').addClass('is--hide');
				setTimeout(function () {
					$('body[data-page="service__index"]').removeAttr('style');
					$('.container[data-page="service__index"]').removeAttr('style');
				}, 1000);
				$('.wrap[data-page="service__index"] .mainvisual .mainvisual--text .text').addClass('is--visible');
				$('.wrap[data-page="service__index"] .mainvisual .overray').addClass('is--visible');
			} else if (delta > 0 && $(window).scrollTop() == 0) {
				$('body[data-page="service__index"]').css('overflow', 'hidden');
				$('.container[data-page="service__index"]').css('display', 'none');
				$('.wrap[data-page="service__index"] .mainvisual h2').removeClass('is--hide');
				$('.wrap[data-page="service__index"] .mainvisual .mainvisual--text .text').removeClass('is--visible');
				$('.wrap[data-page="service__index"] .mainvisual .overray').removeClass('is--visible');
			}
		}
	});
	$('html').keyup(function (e) {
		switch (e.which) {
			case 34:
			case 40:
				$('.wrap[data-page="service__index"] .mainvisual .message--service').addClass('is--scroll');
				$('.wrap[data-page="service__index"] .mainvisual h2').addClass('is--hide');
				setTimeout(function () {
					$('body[data-page="service__index"]').removeAttr('style');
					$('.container[data-page="service__index"]').removeAttr('style');
				}, 1000);
				$('.wrap[data-page="service__index"] .mainvisual .mainvisual--text .text').addClass('is--visible');
				$('.wrap[data-page="service__index"] .mainvisual .overray').addClass('is--visible');
				break;
			case 33:
			case 38:
				if ($(window).scrollTop() == 0) {
					$('body[data-page="service__index"]').css('overflow', 'hidden');
					$('.container[data-page="service__index"]').css('display', 'none');
					$('.wrap[data-page="service__index"] .mainvisual h2').removeClass('is--hide');
					$('.wrap[data-page="service__index"] .mainvisual .mainvisual--text .text').removeClass('is--visible');
					$('.wrap[data-page="service__index"] .mainvisual .overray').removeClass('is--visible');
				}
				break;
		}
	});
	// $(window).on('scroll',function(){
	// 	var top = $(window).scrollTop();
	// 	const height = $(window).height();
	//
	// 	if(top > 50){
	// 		$('.wrap[data-page="service__index"] .mainvisual .mainvisual--title h2').addClass('is--hide');
	// 		$('.wrap[data-page="service__index"] .mainvisual .mainvisual--text .text').addClass('is--visible');
	// 		$('.wrap[data-page="service__index"] .mainvisual .overray').addClass('is--visible');
	// 	}else if(top <= 50){
	// 		$('.wrap[data-page="service__index"] .mainvisual .mainvisual--title h2').removeClass('is--hide');
	// 		$('.wrap[data-page="service__index"] .mainvisual .mainvisual--text .text').removeClass('is--visible');
	// 		$('.wrap[data-page="service__index"] .mainvisual .overray').removeClass('is--visible');
	// 	}
	//
	// });
}

module.exports = serviceIndex;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isDevice = __webpack_require__(0);
var onYouTubeIframeAPIReady = __webpack_require__(20);
var adjustMovieSize = __webpack_require__(12);

//mousewheeleventのクロスブラウザ対策
if ('onwheel' in document) {
	var mousewheelevent = 'wheel';
} else if ('onmousewheel' in document) {
	var mousewheelevent = 'mousewheel';
} else {
	var mousewheelevent = 'DOMMouseScroll';
}

var $window = $(window);
var $body = $('body');
var $wrap = $('.wrap');

//mausewheeleventのロック状態
var isMouseWheelLock = false;

//sectionの並び順
var section_ary = ['mainvisual', 'debug', 'localize', 'illust', 'promo', 'print'];

var VIDEO_ID = ['', 'LQGw-Bq7gbI', 'Mva8wG_PUKU', 'wE3_LNl8fD4', 'jvcTQWZXIXQ', '6WeMeWu_x3A'];

var VIDEO_RATE = [0, 1.2, 1, 1.2, 1, 1];

var section_ary_len = section_ary.length;

function FnTop() {
	this.init();
}

FnTop.prototype = {
	init: function init() {
		var self = this;

		// VIDEO_ID = ($('html').data('ytid').split(","));
		//console.log(VIDEO_ID);

		$window.on(mousewheelevent, function (e) {
			if ($('body')[0].getAttribute('data-category') == 'top') {
				e.preventDefault();
				self.onEvent(e);
				$(document).on('click', '.btn--pagetop', function () {
					$wrap[0].setAttribute('data-current', 'mainvisual');
					$body[0].setAttribute('data-current', 'mainvisual');
					$('.section--top--print').removeClass('is--current');
					$('.section--top--print .section--top__main').removeClass('is--current');
					$('.section--top--mainvisual').addClass('is--current');
					$('.footer').removeClass('is--current');
					$wrap.removeAttr('style');
					setTimeout(function () {
						$('.section--top--print' + ' .section--top__bg').html('<div id="bgMovie--print">');
					}, 500);
				});
			}
		});
	},
	onEvent: function onEvent(e) {

		var hash = this.getHash();
		var delta = this.getDelta(e);

		if (isMouseWheelLock === false) {
			//mousewheelevent時の動作
			if (delta < 0 && hash !== section_ary[section_ary_len - 1]) {
				var next = section_ary.indexOf(hash) + 1;
				$wrap[0].setAttribute('data-current', section_ary[next]);
				$body[0].setAttribute('data-current', section_ary[next]);
				$('.section--top--' + hash).removeClass('is--current');
				$('.section--top--' + hash + ' .section--top__main').removeClass('is--current');
				$('.section--top--' + section_ary[next]).addClass('is--current');
				onYouTubeIframeAPIReady(VIDEO_ID[next], section_ary[next], VIDEO_RATE[next]);
				adjustMovieSize(section_ary[next]);
				setTimeout(function () {
					$('.section--top--' + hash + ' .section--top__bg').html('<div id="bgMovie--' + hash + '">');
				}, 500);
			} else if (delta < 0 && hash == 'print') {
				$wrap.css('transform', 'translateY(-580%)');
				$('.footer').addClass('is--current');
			} else if (delta > 0 && $('.footer').hasClass('is--current')) {
				$wrap.removeAttr('style');
				$('.footer').removeClass('is--current');
			} else if (delta > 0 && !(hash == '' || hash == section_ary[0])) {
				var prev = section_ary.indexOf(hash) - 1;
				$wrap[0].setAttribute('data-current', section_ary[prev]);
				$body[0].setAttribute('data-current', section_ary[prev]);
				$('.section--top--' + hash).removeClass('is--current');
				$('.section--top--' + hash + ' .section--top__main').removeClass('is--current');
				$('.section--top--' + section_ary[prev]).addClass('is--current');
				onYouTubeIframeAPIReady(VIDEO_ID[prev], section_ary[prev], VIDEO_RATE[prev]);
				adjustMovieSize(section_ary[prev]);
				setTimeout(function () {
					$('.section--top--' + hash + ' .section--top__bg').html('<div id="bgMovie--' + hash + '">');
				}, 500);
			}

			//mouseWheelをロック
			isMouseWheelLock = true;

			//mouseWheelのロックを解除
			setTimeout(function () {
				isMouseWheelLock = false;
			}, 1500);
		}
	},
	getHash: function getHash() {
		//現在位置を取得
		var hash = $wrap[0].getAttribute('data-current');
		return hash;
	},
	getDelta: function getDelta(e) {
		//mausuwheelの方向を取得
		if (e.originalEvent.deltaY) {
			var delta = -e.originalEvent.deltaY;
		} else if (e.originalEvent.wheelDelta) {
			var delta = e.originalEvent.wheelDelta;
		} else {
			var delta = -e.origtruevent.detail;
		}
		return delta;
	},
	news: function news() {}
};

module.exports = FnTop;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function TopMainvisual() {
	this.$window = $(window);
	this.imgWidth = 4000;
	this.imgHeight = 1850;

	this.init();
}

TopMainvisual.prototype = {
	init: function init() {
		this.setPositionWidth('.mt__link--debug', 2852, 362, 567);
		this.setPositionWidth('.mt__link--localize', 774, 790, 898);
		this.setPositionWidth('.mt__link--illust', 1906, 0, 921);
		this.setPositionWidth('.mt__link--promo', 1011, 82, 930);
		this.setPositionWidth('.mt__link--print', 226, 316, 923);

		this.setPosition('.mt__icon--debug', 3107, 967);
		this.setPosition('.mt__icon--localize', 1333, 1263);
		this.setPosition('.mt__icon--illust', 2458, 324);
		this.setPosition('.mt__icon--promo', 1311, 236);
		this.setPosition('.mt__icon--print', 804, 430);

		this.setPosition('.mt__balloon--debug', 2930, 1127);
		this.setPosition('.mt__balloon--localize', 1184, 1461);
		this.setPosition('.mt__balloon--illust', 2329, 534);
		this.setPosition('.mt__balloon--promo', 1116, 438);
		this.setPosition('.mt__balloon--print', 560, 570);

		this.setPosition('.mt__obj--print', 215, 316);

		//this.setPosition('.mt__airship01', 1506, 748);
		//this.setPosition('.mt__airship02', 1506, 748);

		this.setPositionWidth('.mt__airship--wrap', 1506, 748, 1492);

		// $('.mt__airship01, .mt__airship02').css({
		// 	transform: 'translate(200%, 0)'
		// });
		$('.mt__airship').addClass('is--visible');

		// $(document).on('mouseover', '.mt__balloon', function(){
		// 	$(this).addClass('is--mouseover');
		// });
		// $(document).on('mouseout', '.mt__balloon', function(){
		// 	$(this).removeClass('is--mouseover');
		// });
	},
	setPositionWidth: function setPositionWidth(el, r, b, w) {
		$(el).css({
			right: this.getRightValue(r),
			bottom: this.getBottomValue(b),
			width: this.getWidthValue(w)
		});
	},
	setPosition: function setPosition(el, r, b) {
		$(el).css({
			right: this.getRightValue(r),
			bottom: this.getBottomValue(b)
		});
	},
	getRightValue: function getRightValue(n) {
		return n * this.getImgReduction() - this.getImgOverflowWidth();
	},
	getBottomValue: function getBottomValue(n) {
		return n * this.getImgReduction();
	},
	getWidthValue: function getWidthValue(n) {
		return n * this.getImgReduction();
	},
	getImgAspect: function getImgAspect() {
		return this.imgWidth / this.imgHeight;
	},
	getWindowWidth: function getWindowWidth() {
		return this.$window.width();
	},
	getWindowHeight: function getWindowHeight() {
		return this.$window.height();
	},
	getImgReduction: function getImgReduction() {
		return this.getWindowHeight() / this.imgHeight;
	},
	getImgReductionWidth: function getImgReductionWidth() {
		return this.imgWidth * this.getImgReduction();
	},
	getImgOverflowWidth: function getImgOverflowWidth() {
		return (this.getImgReductionWidth() - this.getWindowWidth()) / 2;
	}
};

module.exports = TopMainvisual;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function topMainvisualEffect() {
	var ary = ['top', 'debug', 'localize', 'illust', 'promo', 'print'];

	var n;

	var setRandom = setInterval(function () {
		var rand = Math.floor(Math.random() * 6);

		if (rand == n && rand < 5) {
			n = rand + 1;
		} else if (rand == n && rand == 5) {
			n = 0;
		} else {
			n = rand;
		}

		var i = n + 1;

		if (n == 0) {
			var link = '';
		} else {
			var link = '/service/' + ary[n];
		}

		$('.mt__icon--' + ary[n]).addClass('is--mouseover');
		$('.mt__balloon--' + ary[n]).addClass('is--mouseover');
		$('.mt__airship__link').attr('href', link);
		$('.mt__airship__link').removeAttr('style');
		if (ary[n] == 'top') {
			$('.mt__airship__link').css({
				'cursor': 'default',
				'pointer-events': 'none'
			});
		}
		//$('.mt__airship ul').attr('class','is--' + ary[n]);
		$('.mt__airship ul li:nth-of-type(' + i + ')').addClass('is--visible').siblings().removeClass('is--visible');
		setTimeout(function () {
			$('.mt__icon--' + ary[n]).removeClass('is--mouseover');
			$('.mt__balloon--' + ary[n]).removeClass('is--mouseover');
		}, 3000);
	}, 4000);
	$(document).on('mouseover', '.mt__link', function () {
		clearInterval(setRandom);
		$(this).next('img').addClass('is--mouseover');
		$(this).next('img').next('img').addClass('is--mouseover');
		var service = $(this)[0].getAttribute('data-service');
		var n = ary.indexOf(service) + 1;
		$('.mt__airship__link').attr('href', '/service/' + service);
		$('.mt__airship ul li:nth-of-type(' + n + ')').addClass('is--visible').siblings().removeClass('is--visible');
	});
	$(document).on('mouseout', '.mt__link', function () {
		$(this).next('img').removeClass('is--mouseover');
		$(this).next('img').next('img').removeClass('is--mouseover');
		setRandom = setInterval(function () {
			var rand = Math.floor(Math.random() * 6);

			if (rand == n && rand < 5) {
				n = rand + 1;
			} else if (rand == n && rand == 5) {
				n = 0;
			} else {
				n = rand;
			}

			var i = n + 1;

			if (n == 0) {
				var link = '';
			} else {
				var link = '/service/' + ary[n];
			}

			$('.mt__icon--' + ary[n]).addClass('is--mouseover');
			$('.mt__balloon--' + ary[n]).addClass('is--mouseover');
			$('.mt__airship__link').attr('href', link);
			$('.mt__airship__link').removeAttr('style');
			if (ary[n] == 'top') {
				$('.mt__airship__link').css({
					'cursor': 'default',
					'pointer-events': 'none'
				});
			}
			//$('.mt__airship ul').attr('class','is--' + ary[n]);
			$('.mt__airship ul li:nth-of-type(' + i + ')').addClass('is--visible').siblings().removeClass('is--visible');
			setTimeout(function () {
				$('.mt__icon--' + ary[n]).removeClass('is--mouseover');
				$('.mt__balloon--' + ary[n]).removeClass('is--mouseover');
			}, 3000);
		}, 4000);
	});
}

module.exports = topMainvisualEffect;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function newsTop() {
	var news_length = $('.section--top--mainvisual__news__ul').find('li').length;
	$('.section--top--mainvisual__news__ul').css('width', 360 * news_length);
	var count = 1;
	$('.section--top--mainvisual__news .number').html(count + '/' + news_length);

	$(document).on('click', '.section--top--mainvisual__news .btn li a', function (e) {
		e.preventDefault();
		if ($(this).parent().hasClass('prev') && count > 1) {
			var n = 360 * (count - 1) - 360;
			$('.section--top--mainvisual__news__ul').css('transform', 'translateX(-' + n + 'px)');
			count--;
			$('.section--top--mainvisual__news .number').html(count + '/' + news_length);
		} else if ($(this).parent().hasClass('next') && count < news_length) {
			count++;
			var n = 360 * (count - 1);
			$('.section--top--mainvisual__news__ul').css('transform', 'translateX(-' + n + 'px)');
			$('.section--top--mainvisual__news .number').html(count + '/' + news_length);
		} else if (count = news_length) {
			count = 0;
		}
	});
}

module.exports = newsTop;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function topNewsSlider() {
	var topics = setInterval(function () {
		$('.section--top--mainvisual__news .btn li:nth-of-type(2) a').trigger('click');
	}, 3000);

	$(document).on('mouseover', '.section--top--mainvisual__news .btn li a', function (e) {
		clearInterval(topics);
	});
	$(document).on('mouseout', '.section--top--mainvisual__news .btn li a', function (e) {
		topics = setInterval(function () {
			$('.section--top--mainvisual__news .btn li:nth-of-type(2) a').trigger('click');
		}, 3000);
	});
}

module.exports = topNewsSlider;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ua = __webpack_require__(0);
var Pjax = __webpack_require__(1);

var isIphone = ua('iphone');
var isAndroid = ua('android');

Pjax.init();

$(function () {
	if (sessionStorage.entrance == 'is--hide') {
		$('.entrance').addClass('is--hide');
	}
});

// if($('body').hasClass('page--top')){
// 	new OnMouseWheel();
// 	$(window).on('load',function(){
// 		setTimeout(function(){
// 			$('.section--mainvisual .title').addClass('is--show');
// 		}, 2000);
// 		setTimeout(function(){
// 			$('.header').addClass('is--show');
// 			$('.information').addClass('is--show');
// 		}, 3000);
// 	});
// 	$('.section--target').on({
// 		mouseover: function(){
// 			$(this).parent().addClass('is--mo');
// 		},
// 		mouseout: function(){
// 			$(this).parent().removeClass('is--mo');
// 		}
// 	});
// }
//
// if($('body').hasClass('page--common')){
// 	$(window).scroll(function () {
// 		if ($(this).scrollTop() > 480) {
// 			$('.header').addClass('is--bg');
// 		} else {
// 			$('.header').removeClass('is--bg');
// 		}
// 	});
// }

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var config = {
    movie_asp: 1280 / 720
};
var $window = $(window);

module.exports = function (hash) {
    var width = $window.width();
    var height = $window.height();
    var window_asp = width / height;
    var movie_width = height * config.movie_asp;
    var movie_height = width / config.movie_asp;
    var adjust = -(movie_width - width) / 2;
    if (window_asp >= config.movie_asp) {
        $('#bgMovie--' + hash).css({
            position: 'absolute',
            width: '100%',
            height: movie_height
        });
    } else {
        $('#bgMovie--' + hash).css({
            position: 'absolute',
            width: movie_width,
            height: '100%',
            left: adjust
        });
    }
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function setBtnPageTop() {
	if ($('.wrap')[0].getAttribute('data-page') == 'service__index') {
		var n = $(window).height() * 1.2;
	} else {
		var n = 500;
	}
	$(window).on('scroll', function () {
		var top = $(window).scrollTop();

		if (top > n) {
			$('.btn--pagetop').addClass('is--visible');
		} else if (top <= n) {
			$('.btn--pagetop').removeClass('is--visible');
		}
	});

	$(document).on('click', '.btn--pagetop', function (e) {
		e.preventDefault();
		$('html,body').animate({ scrollTop: 0 }, 'swing');
	});
}

module.exports = setBtnPageTop;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function headerScroll() {
	if ($('.wrap')[0].getAttribute('data-page') == 'service__index') {
		var n = $(window).height() * 1.2;
	} else {
		var n = 300;
	}
	if ($('.section--work__detail').hasClass('is--work__detail')) {
		$('.header').addClass('is--scroll');
	}
	$(window).on('scroll', function () {
		var top = $(window).scrollTop();

		if (top > n) {
			$('.header').addClass('is--scroll');
		} else if (top <= n && !$('.section--work__detail').hasClass('is--work__detail')) {
			$('.header').removeClass('is--scroll');
		}
	});
}

module.exports = headerScroll;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_LOCAL_MODULE_0__, __WEBPACK_LOCAL_MODULE_0__factory, __WEBPACK_LOCAL_MODULE_0__module;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * imagesLoaded PACKAGED v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

!function (e, t) {
   true ? !(__WEBPACK_LOCAL_MODULE_0__factory = (t), (__WEBPACK_LOCAL_MODULE_0__module = { id: "ev-emitter/ev-emitter", exports: {}, loaded: false }), __WEBPACK_LOCAL_MODULE_0__ = (typeof __WEBPACK_LOCAL_MODULE_0__factory === 'function' ? (__WEBPACK_LOCAL_MODULE_0__factory.call(__WEBPACK_LOCAL_MODULE_0__module.exports, __webpack_require__, __WEBPACK_LOCAL_MODULE_0__module.exports, __WEBPACK_LOCAL_MODULE_0__module)) : __WEBPACK_LOCAL_MODULE_0__factory), (__WEBPACK_LOCAL_MODULE_0__module.loaded = true), __WEBPACK_LOCAL_MODULE_0__ === undefined && (__WEBPACK_LOCAL_MODULE_0__ = __WEBPACK_LOCAL_MODULE_0__module.exports)) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = t() : e.EvEmitter = t();
}("undefined" != typeof window ? window : undefined, function () {
  function e() {}var t = e.prototype;return t.on = function (e, t) {
    if (e && t) {
      var i = this._events = this._events || {},
          n = i[e] = i[e] || [];return n.indexOf(t) == -1 && n.push(t), this;
    }
  }, t.once = function (e, t) {
    if (e && t) {
      this.on(e, t);var i = this._onceEvents = this._onceEvents || {},
          n = i[e] = i[e] || {};return n[t] = !0, this;
    }
  }, t.off = function (e, t) {
    var i = this._events && this._events[e];if (i && i.length) {
      var n = i.indexOf(t);return n != -1 && i.splice(n, 1), this;
    }
  }, t.emitEvent = function (e, t) {
    var i = this._events && this._events[e];if (i && i.length) {
      i = i.slice(0), t = t || [];for (var n = this._onceEvents && this._onceEvents[e], o = 0; o < i.length; o++) {
        var r = i[o],
            s = n && n[r];s && (this.off(e, r), delete n[r]), r.apply(this, t);
      }return this;
    }
  }, t.allOff = function () {
    delete this._events, delete this._onceEvents;
  }, e;
}), function (e, t) {
  "use strict";
   true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__WEBPACK_LOCAL_MODULE_0__], __WEBPACK_AMD_DEFINE_RESULT__ = function (i) {
    return t(e, i);
  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = t(e, require("ev-emitter")) : e.imagesLoaded = t(e, e.EvEmitter);
}("undefined" != typeof window ? window : undefined, function (e, t) {
  function i(e, t) {
    for (var i in t) {
      e[i] = t[i];
    }return e;
  }function n(e) {
    if (Array.isArray(e)) return e;var t = "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && "number" == typeof e.length;return t ? d.call(e) : [e];
  }function o(e, t, r) {
    if (!(this instanceof o)) return new o(e, t, r);var s = e;return "string" == typeof e && (s = document.querySelectorAll(e)), s ? (this.elements = n(s), this.options = i({}, this.options), "function" == typeof t ? r = t : i(this.options, t), r && this.on("always", r), this.getImages(), h && (this.jqDeferred = new h.Deferred()), void setTimeout(this.check.bind(this))) : void a.error("Bad element for imagesLoaded " + (s || e));
  }function r(e) {
    this.img = e;
  }function s(e, t) {
    this.url = e, this.element = t, this.img = new Image();
  }var h = e.jQuery,
      a = e.console,
      d = Array.prototype.slice;o.prototype = Object.create(t.prototype), o.prototype.options = {}, o.prototype.getImages = function () {
    this.images = [], this.elements.forEach(this.addElementImages, this);
  }, o.prototype.addElementImages = function (e) {
    "IMG" == e.nodeName && this.addImage(e), this.options.background === !0 && this.addElementBackgroundImages(e);var t = e.nodeType;if (t && u[t]) {
      for (var i = e.querySelectorAll("img"), n = 0; n < i.length; n++) {
        var o = i[n];this.addImage(o);
      }if ("string" == typeof this.options.background) {
        var r = e.querySelectorAll(this.options.background);for (n = 0; n < r.length; n++) {
          var s = r[n];this.addElementBackgroundImages(s);
        }
      }
    }
  };var u = { 1: !0, 9: !0, 11: !0 };return o.prototype.addElementBackgroundImages = function (e) {
    var t = getComputedStyle(e);if (t) for (var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(t.backgroundImage); null !== n;) {
      var o = n && n[2];o && this.addBackground(o, e), n = i.exec(t.backgroundImage);
    }
  }, o.prototype.addImage = function (e) {
    var t = new r(e);this.images.push(t);
  }, o.prototype.addBackground = function (e, t) {
    var i = new s(e, t);this.images.push(i);
  }, o.prototype.check = function () {
    function e(e, i, n) {
      setTimeout(function () {
        t.progress(e, i, n);
      });
    }var t = this;return this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? void this.images.forEach(function (t) {
      t.once("progress", e), t.check();
    }) : void this.complete();
  }, o.prototype.progress = function (e, t, i) {
    this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded, this.emitEvent("progress", [this, e, t]), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, e), this.progressedCount == this.images.length && this.complete(), this.options.debug && a && a.log("progress: " + i, e, t);
  }, o.prototype.complete = function () {
    var e = this.hasAnyBroken ? "fail" : "done";if (this.isComplete = !0, this.emitEvent(e, [this]), this.emitEvent("always", [this]), this.jqDeferred) {
      var t = this.hasAnyBroken ? "reject" : "resolve";this.jqDeferred[t](this);
    }
  }, r.prototype = Object.create(t.prototype), r.prototype.check = function () {
    var e = this.getIsImageComplete();return e ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image(), this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), this.img.addEventListener("load", this), this.img.addEventListener("error", this), void (this.proxyImage.src = this.img.src));
  }, r.prototype.getIsImageComplete = function () {
    return this.img.complete && this.img.naturalWidth;
  }, r.prototype.confirm = function (e, t) {
    this.isLoaded = e, this.emitEvent("progress", [this, this.img, t]);
  }, r.prototype.handleEvent = function (e) {
    var t = "on" + e.type;this[t] && this[t](e);
  }, r.prototype.onload = function () {
    this.confirm(!0, "onload"), this.unbindEvents();
  }, r.prototype.onerror = function () {
    this.confirm(!1, "onerror"), this.unbindEvents();
  }, r.prototype.unbindEvents = function () {
    this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
  }, s.prototype = Object.create(r.prototype), s.prototype.check = function () {
    this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.url;var e = this.getIsImageComplete();e && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents());
  }, s.prototype.unbindEvents = function () {
    this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
  }, s.prototype.confirm = function (e, t) {
    this.isLoaded = e, this.emitEvent("progress", [this, this.element, t]);
  }, o.makeJQueryPlugin = function (t) {
    t = t || e.jQuery, t && (h = t, h.fn.imagesLoaded = function (e, t) {
      var i = new o(this, e, t);return i.jqDeferred.promise(h(this));
    });
  }, o.makeJQueryPlugin(), o;
});

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function runInview() {
	$(window).scroll(function () {
		$(".inview").each(function () {
			var imgPos = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > imgPos - windowHeight + windowHeight / 5) {
				$(this).addClass('is--inveiw');
			} else {
				//$(this).removeClass('is--inveiw');
			}
		});
	});

	$(".inview").each(function () {
		var imgPos = $(this).offset().top;
		var scroll = $(window).scrollTop();
		var windowHeight = $(window).height();
		if (scroll > imgPos - windowHeight + windowHeight / 5) {
			$(this).addClass('is--inveiw');
		} else {
			//$(this).removeClass('is--inveiw');
		}
	});
}

module.exports = runInview;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wookmark = __webpack_require__(18);
var imagesLoaded = __webpack_require__(15);

function runWoookmark() {
	if ($('.section--work').hasClass('is--illust--work')) {
		$('.grid-item').imagesLoaded(function () {
			$('.grid').wookmark({
				autoResize: true,
				offset: 0
			});
		});
	}
}

module.exports = runWoookmark;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
wookmark plugin
@name wookmark.js
@author Christoph Ono (chri@sto.ph or @gbks)
@author Sebastian Helzle (sebastian@helzle.net or @sebobo)
@version 2.1.2
@date 05/05/2016
@category jQuery plugin
@copyright (c) 2009-2016 Christoph Ono (www.wookmark.com)
@license Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php) license.
*/
!function (a) {
  !function (a) {
     true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (a),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : a();
  }(function () {
    function c(a, b) {
      return function () {
        return a.apply(b, arguments);
      };
    }function e(a, b) {
      var c;for (c in b) {
        b.hasOwnProperty(c) && (a.style[c] = b[c]);
      }
    }function f(a, b) {
      d(function () {
        var c, f;for (c = 0; c < a.length; c++) {
          f = a[c], e(f.el, f.css);
        }"function" == typeof b && d(b);
      });
    }function g(a) {
      return a.replace(/^\s+|\s+$/g, "").toLowerCase();
    }function h(b, c, d) {
      window.jQuery ? a(b).off(c, d) : b.removeEventListener ? b.removeEventListener(c, d) : b.detachEvent("on" + c, d);
    }function i(b, c, d) {
      h(b, c, d), window.jQuery ? a(b).on(c, d) : b.addEventListener ? b.addEventListener(c, d) : b.attachEvent("on" + c, function () {
        d.call(b);
      });
    }function j(a) {
      return null === a.offsetParent;
    }function k(a) {
      return a.offsetHeight;
    }function l(a) {
      return a.offsetWidth;
    }function m(a, b) {
      return a.classList ? a.classList.contains(b) : new RegExp("(^| )" + b + "( |$)", "gi").test(a.className);
    }function n(a, b) {
      a.classList ? a.classList.add(b) : a.className += " " + b;
    }function o(a, b) {
      a.classList ? a.classList.remove(b) : a.className = a.className.replace(new RegExp("(^|\\b)" + b.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }function p(a, b, c, d) {
      void 0 === d && (d = "wookmark-");var e = a.getAttribute("data-" + d + b);return c === !0 ? parseInt(e, 10) : e;
    }function q(a, b, c, d) {
      void 0 === d && (d = "wookmark-"), a.setAttribute("data-" + d + b, c);
    }function r(a) {
      for (var d, b = {}, c = [], e = a.length; e--;) {
        d = p(a[e], "id", !0), b.hasOwnProperty(d) || (b[d] = 1, c.push(a[e]));
      }return c;
    }function s(a, b) {
      return void 0 !== window.getComputedStyle ? window.getComputedStyle(a, null).getPropertyValue(b) : a.currentStyle[b];
    }function t(a, b) {
      var d,
          c = a.length;for (d = 0; d < c; d++) {
        if (a[d] === b) return d;
      }return -1;
    }function u(a, b) {
      b = b || {}, "string" == typeof a && (a = document.querySelector(a)), this.container = a, this.columns = this.resizeTimer = null, this.activeItemCount = 0, this.placeholders = [], this.itemHeightsInitialized = !1, this.itemHeightsDirty = !1, this.elementTag = "div", this.initItems = c(this.initItems, this), this.updateOptions = c(this.updateOptions, this), this.onResize = c(this.onResize, this), this.onRefresh = c(this.onRefresh, this), this.getItemWidth = c(this.getItemWidth, this), this.layout = c(this.layout, this), this.layoutFull = c(this.layoutFull, this), this.layoutColumns = c(this.layoutColumns, this), this.filter = c(this.filter, this), this.clear = c(this.clear, this), this.getActiveItems = c(this.getActiveItems, this), this.refreshPlaceholders = c(this.refreshPlaceholders, this), this.sortElements = c(this.sortElements, this), this.updateFilterClasses = c(this.updateFilterClasses, this), this.initItems(), this.container.style.display = "block", this.updateOptions(b), this.updateFilterClasses(), this.autoResize && i(window, "resize", this.onResize), i(this.container, "refreshWookmark", this.onRefresh);
    }var b = { align: "center", autoResize: !0, comparator: null, direction: void 0, ignoreInactiveItems: !0, inactiveClass: "wookmark-inactive", itemSelector: void 0, itemWidth: 0, fillEmptySpace: !1, flexibleWidth: 0, offset: 5, outerOffset: 0, onLayoutChanged: void 0, placeholderClass: "wookmark-placeholder", possibleFilters: [], resizeDelay: 50, verticalOffset: void 0 },
        d = window.requestAnimationFrame || function (a) {
      a();
    };return u.prototype.initItems = function () {
      if (void 0 === this.itemSelector) {
        for (var b, a = [], c = this.container.children, d = c.length; d--;) {
          b = c[d], 8 !== b.nodeType && (b.style.display = "", q(b, "id", d), a.unshift(b));
        }this.items = a;
      } else this.items = this.container.querySelectorAll(this.itemSelector);this.items.length && (this.elementTag = this.items[0].tagName), this.itemHeightsDirty = !0;
    }, u.prototype.updateFilterClasses = function () {
      for (var b, d, e, f, j, a = this.items.length, c = {}, h = this.possibleFilters, i = h.length; a--;) {
        if (e = this.items[a], d = JSON.parse(p(e, "filter-class", !1, "")), d && "object" == (typeof d === "undefined" ? "undefined" : _typeof(d))) for (b = d.length; b--;) {
          f = g(d[b]), c.hasOwnProperty(f) || (c[f] = []), c[f].push(e);
        }
      }for (; i--;) {
        j = g(h[i]), c.hasOwnProperty(j) || (c[j] = []);
      }this.filterClasses = c;
    }, u.prototype.updateOptions = function (a) {
      var c;this.itemHeightsDirty = !0, a = a || {};for (c in b) {
        b.hasOwnProperty(c) && (a.hasOwnProperty(c) ? this[c] = a[c] : this.hasOwnProperty(c) || (this[c] = b[c]));
      }this.verticalOffset = this.verticalOffset || this.offset, this.layout(!0);
    }, u.prototype.onResize = function () {
      clearTimeout(this.resizeTimer), this.itemHeightsDirty = 0 !== this.flexibleWidth, this.resizeTimer = setTimeout(this.layout, this.resizeDelay);
    }, u.prototype.onRefresh = function () {
      this.itemHeightsDirty = !0, this.layout();
    }, u.prototype.filter = function (a, b, c) {
      var e,
          h,
          i,
          j,
          k,
          d = [],
          f = [];if (a = a || [], b = b || "or", c = c || !1, a.length) {
        for (h = 0; h < a.length; h++) {
          k = g(a[h]), this.filterClasses.hasOwnProperty(k) && d.push(this.filterClasses[k]);
        }if (h = e = d.length, "or" === b || 1 === e) for (; h--;) {
          f = f.concat(d[h]);
        } else if ("and" === b) {
          for (var p, q, s, l = d[0], m = !0; h--;) {
            d[h].length < l.length && (l = d[h]);
          }for (l = l || [], h = l.length; h--;) {
            for (q = l[h], i = e, m = !0; i-- && m;) {
              if (s = d[i], l !== s) {
                for (p = !1, j = s.length; j-- && !p;) {
                  p = s[j] === q;
                }m &= p;
              }
            }m && (f = f.concat(l[h]));
          }
        }if (e > 1 && (f = r(f)), !c) for (h = this.items.length; h--;) {
          t(f, this.items[h]) === -1 && n(this.items[h], this.inactiveClass);
        }
      } else f = this.items;if (!c) {
        for (h = f.length; h--;) {
          o(f[h], this.inactiveClass);
        }this.columns = null, this.layout();
      }return f;
    }, u.prototype.refreshPlaceholders = function (a, b) {
      var c,
          g,
          h,
          i,
          j,
          m,
          n,
          d = k(this.container),
          f = this.columns.length,
          l = "";if (this.placeholders.length < f) {
        for (c = 0; c < f - this.placeholders.length; c++) {
          l += "<" + this.elementTag + ' class="' + this.placeholderClass + '"/>';
        }this.container.insertAdjacentHTML("beforeend", l), this.placeholders = this.container.querySelectorAll("." + this.placeholderClass);
      }for (i = this.offset + 2 * parseInt(s(this.placeholders[0], "border-left-width"), 10) || 0, i += 2 * parseInt(s(this.placeholders[0], "padding-left"), 10) || 0, c = 0; c < this.placeholders.length; c++) {
        m = this.placeholders[c], g = this.columns[c], c >= f || 0 === g.length ? m.style.display = "none" : (j = g[g.length - 1], n = p(j, "top", !0) + p(j, "height", !0) + this.verticalOffset, h = Math.max(0, d - n - i), e(m, { position: "absolute", display: h > 0 ? "block" : "none", left: c * a + b + "px", top: n + "px", width: a - i + "px", height: h + "px" }));
      }
    }, u.prototype.getActiveItems = function () {
      var b,
          d,
          a = this.inactiveClass,
          c = [],
          e = this.items;if (!this.ignoreInactiveItems) return e;for (b = 0; b < e.length; b++) {
        d = e[b], m(d, a) || c.push(d);
      }return c;
    }, u.prototype.getItemWidth = function () {
      var a = this.itemWidth,
          b = l(this.container) - 2 * this.outerOffset,
          c = this.flexibleWidth;if ("function" == typeof a && (a = this.itemWidth()), this.items.length > 0 && (void 0 === a || 0 === a && !this.flexibleWidth) ? a = l(this.items[0]) : "string" == typeof a && a.indexOf("%") >= 0 && (a = parseFloat(a) / 100 * b), c) {
        "function" == typeof c && (c = c()), "string" == typeof c && c.indexOf("%") >= 0 && (c = parseFloat(c) / 100 * b);var d = b + this.offset,
            e = Math.floor(.5 + d / (c + this.offset)),
            f = Math.floor(d / (a + this.offset)),
            g = Math.max(e, f),
            h = Math.min(c, Math.floor((b - (g - 1) * this.offset) / g));a = Math.max(a, h);
      }return a;
    }, u.prototype.layout = function (a, b) {
      if (a || !j(this.container)) {
        var h,
            n,
            c = this.getItemWidth(),
            d = c + this.offset,
            e = l(this.container),
            f = e - 2 * this.outerOffset,
            g = Math.floor((f + this.offset) / d),
            i = 0,
            k = this.getActiveItems(),
            m = k.length;if (a || this.itemHeightsDirty || !this.itemHeightsInitialized) {
          for (var o = 0; o < m; o++) {
            n = k[o], this.flexibleWidth && (n.style.width = c + "px"), q(n, "height", n.offsetHeight);
          }this.itemHeightsDirty = !1, this.itemHeightsInitialized = !0;
        }g = Math.max(1, Math.min(g, m)), h = this.outerOffset, "center" === this.align && (h += Math.floor(.5 + (f - (g * d - this.offset)) >> 1)), this.direction = this.direction || ("right" === this.align ? "right" : "left"), i = a || null === this.columns || this.columns.length !== g || this.activeItemCount !== m ? this.layoutFull(d, g, h) : this.layoutColumns(d, h), this.activeItemCount = m, this.container.style.height = i + "px", this.fillEmptySpace && this.refreshPlaceholders(d, h), void 0 !== this.onLayoutChanged && "function" == typeof this.onLayoutChanged && this.onLayoutChanged(), "function" == typeof b && b();
      }
    }, u.prototype.sortElements = function (a) {
      return "function" == typeof this.comparator ? a.sort(this.comparator) : a;
    }, u.prototype.layoutFull = function (a, b, c) {
      var d,
          h,
          i,
          l,
          e = 0,
          g = 0,
          j = null,
          k = null,
          o = [],
          r = [],
          s = "left" === this.align,
          t = this;for (this.columns = [], h = this.sortElements(this.getActiveItems()), i = h.length; o.length < b;) {
        o.push(this.outerOffset), this.columns.push([]);
      }for (; g < i;) {
        for (d = h[g], j = o[0], k = 0, e = 0; e < b; e++) {
          o[e] < j && (j = o[e], k = e);
        }q(d, "top", j), l = c, (k > 0 || !s) && (l += k * a), r[g] = { el: d, css: { position: "absolute", top: j + "px" } }, r[g].css[this.direction] = l + "px", o[k] += p(d, "height", !0) + this.verticalOffset, this.columns[k].push(d), g++;
      }return f(r, function () {
        m(t.container, "wookmark-initialised") || n(t.container, "wookmark-initialised");
      }), Math.max.apply(Math, o);
    }, u.prototype.layoutColumns = function (a, b) {
      for (var i, j, k, l, c = [], d = [], e = 0, g = 0, h = this.columns.length; h--;) {
        for (i = this.outerOffset, c.push(i), j = this.columns[h], l = h * a + b, e = 0; e < j.length; e++, g++) {
          k = j[e], q(k, "top", i), d[g] = { el: k, css: { top: i + "px" } }, d[g].css[this.direction] = l + "px", i += p(k, "height", !0) + this.verticalOffset;
        }c[h] = i;
      }return f(d), Math.max.apply(Math, c);
    }, u.prototype.clear = function () {
      clearTimeout(this.resizeTimer);for (var a = this.placeholders.length; a--;) {
        this.container.removeChild(this.placeholders[a]);
      }h(window, "resize", this.onResize), h(this.container, "refreshWookmark", this.onRefresh);
    }, void 0 !== window.jQuery && (jQuery.fn.wookmark = function (b) {
      var c = this.length;if (void 0 !== b && b.container instanceof jQuery && (b.container = b.container[0]), c > 1) for (; c--;) {
        a(this).eq(c).wookmark(b);
      } else 1 === c && (this.wookmarkInstance ? this.wookmarkInstance.updateOptions(b || {}) : this.wookmarkInstance = new u(this[0], b || {}));return this;
    }), window.Wookmark = u, u;
  });
}(jQuery);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function setWrapMargin() {
	if ($('.wrap')[0].getAttribute('data-category') == 'top') {
		$('.wrap').removeAttr('style');
	} else {
		var n = $(window).height() * .8;
		$('.wrap').css('margin-bottom', n);
	}
}

module.exports = setWrapMargin;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (videoId, hash, rate) {
    var ytPlayer = new YT.Player('bgMovie--' + hash, // 埋め込む場所をIDで設定
    {
        videoId: videoId,
        playerVars: {
            rel: 0,
            loop: 1,
            playlist: videoId,
            controls: 0,
            autoplay: 1,
            //showinfo: 0,
            disablekb: 0,
            wmode: "transparent",
            modestbranding: 1
        },
        events: {
            'onReady': function onReady(event) {
                onPlayerReady(event, hash, rate);
            }
        }
    });
};
//プレイ準備完了後
function onPlayerReady(event, hash, rate) {
    $('.section--top--' + hash + ' .section--top__main').addClass('is--current');
    event.target.setPlaybackRate(rate);
    event.target.playVideo();
    event.target.mute();
}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.min.js